module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.openPop) ? _c('Popup', {
    on: {
      "close": function($event) {
        _vm.openPop = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "table"
    },
    slot: "table"
  }, [_c('h3', {
    staticClass: "py-4"
  }, [_vm._v(_vm._s(_vm.recognizeData.title) + "簡介")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "55vh"
    },
    attrs: {
      "id": "style-1"
    }
  }, [_c('table', {
    staticClass: "table table-borderless"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('learning_contents')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('last_update_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('play')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('download')))])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "text-align": "left"
    }
  }, _vm._l((_vm.recognizeData.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v("\n                " + _vm._s(item.sentence) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.createTime ? item.createTime : '----/--/-- 00:00:00') + "\n              ")]), _vm._v(" "), _c('td', [(item.voiceUrl) ? _c('p', {
      staticClass: "link-tag pointer",
      on: {
        "click": function($event) {
          return _vm.playAudio(item.voiceUrl)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('play')) + "\n                ")]) : _c('p', [_vm._v(_vm._s(_vm.$t('play')))])]), _vm._v(" "), _c('td', [(item.voiceUrl) ? _c('a', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "download": "",
        "target": "_blank",
        "href": item.voiceUrl
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('download')) + "\n                ")]) : _c('p', [_vm._v(_vm._s(_vm.$t('download')))])])])
  }), 0)]), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "audio"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.voiceUrl,
      "type": "audio/ogg"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('div', {
    staticClass: "ml-5"
  }, [_c('h4', [_vm._v(_vm._s(_vm.targetInfo.username) + " | " + _vm._s(_vm.targetInfo.realname) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.userInfo.rolename === 'Teacher') ? _c('div', {
    staticClass: "m-auto type-selecter"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lessonId),
      expression: "lessonId"
    }],
    staticClass: "scene-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lessonId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.LessonList), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.localName))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "back-icon pointer my-4",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "src": require("../../../../assets/image/icon/close_lesson.png")
    },
    on: {
      "click": _vm.previousPage
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 table-responsive",
    staticStyle: {
      "overflow": "auto",
      "font-size": "1.25rem"
    }
  }, [_c('table', {
    staticClass: "table table-borderless table-hover "
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('course_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('unit_theme')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('study_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('views')))]), _vm._v(" "), (_vm.mode === 'App') ? _c('th', [_vm._v(_vm._s(_vm.$t('oral_practice')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "text-align": "left"
    }
  }, _vm._l((_vm.record), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n              " + _vm._s(item.lessonName) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.packageName) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.spendTime ? item.spendTime : '00:00:00') + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.learnCount) + "\n            ")]), _vm._v(" "), (_vm.mode === 'App') ? _c('td', [(item.hasRecognize) ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.openRecognize(item.id, item.packageName)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('view')) + "\n              ")]) : _vm._e()]) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.pageCount > 1) ? _c('pagination', {
    staticClass: "mt-5",
    attrs: {
      "current": _vm.pageIndex,
      "total": _vm.pageCount
    },
    on: {
      "page": _vm.updatePage
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9a3f6154!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/ar/record/Record.vue
// module id = 805
// module chunks = 3